<ng-container>
  <div class="content-container-events-hearings">
    <div class="d-flex justify-content-between">
      <div>
        <div class="p-5">
          @for (category of categories; track category) {
            <button class="toggle" (click)="handleToggle(category)" [class.active]="filterSelection === category">{{category}}</button>
          }
        </div>
      </div>
    </div>
    <div class="ms-3">
      @if (showSpinner) {
        <div class="loading">
          <fa-icon [icon]="faCircleNotch" [animation]="'spin'"></fa-icon>
        </div>
      }
      <div class="table-wrapper">
        @if (filteredEvents?.length == 0) {
          <div>
            <h2>No Upcoming Hearings or Events are scheduled</h2>
          </div>
        }
        @if (filteredEvents && filteredEvents.length > 0) {
          <table class="ms-5 events-hearings striped">
            <thead>
              <tr>
                <th class="dateCol">Date</th>
                <th class="timeCol">State Time</th>
                <th class="titleCol">Event Title</th>
                <th class="eventTypeCol">Type of Event</th>
                <th class="locationCol">Location</th>
                <!--<th class="directionBtnCol"></th>-->
              </tr>
            </thead>
            <tbody>
              @for (event of filteredEvents; track event) {
                <tr>
                  <td class="dateCol">{{ event.startTime ? (event.startTime | date: 'EEEE, MMMM d') : (event.date | date: 'EEEE, MMMM d') }}</td>
                  <td class="timeCol">{{ event.startTime ? (event.startTime | date: 'h:mm a') : (event.date | date: 'h:mm a') }}</td>
                  <td class="titleCol">{{event.name || event.eventTitle}}</td>
                  <td class="eventTypeCol">{{event.type || event.eventType}}</td>
                  <td class="locationCol">{{event.location}}</td>
                  <!--<td class="directionBtnCol">
                  <button class="directionToggle" (click)="getDirection(event.location)">Get Directions</button>
                </td>-->
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  </div>
</div>
</ng-container>

